<template>
    <div class="solution-construction-page">
        <div class="page-content">
            <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
            <el-col class="solution-children-body" :xs="22" :sm="22" :md="20" :lg="16" :xl="16">
                <solution-info-block :data-val="dataInfo"></solution-info-block>
            </el-col>
            <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
        </div>
    </div>
</template>

<script>
    import SolutionInfoBlock from '../../../../../components/solution-info-block/solution-info-block'
    import ConstructionShow from '../../../../image/common/construction_show.png'
    export default {
        name: "solution-construction-page",
        components:{
            SolutionInfoBlock
        },
        data(){
            return{
                dataInfo:{
                    business:[
                        {title:null,info:['如何加强施工现场安全管理、降低事故发生频率、杜绝各种违规操作和不文明施工、提高建筑工程质量，仍将是摆在各级政府部门、业界人士和广大学者面前的一项重要研究课题。如何加强施工现场安全管理、降低事故发生频率、杜绝各种违规操作和不文明施工、提高建筑工程质量，仍将是摆在各级政府部门、业界人士和广大学者面前的一项重要研究课题。']},
                        {list:[
                                {title:'智慧工地有如下建设诉求：',info: null},
                                {title:'1）工地现场人员复杂，施工人员流动性强',info: '施工现场工种种类多，施工队伍多，传统手段难以验证工人身份；施工队伍人员交替频繁、流动性大；加之工地现场开放性管理，闲杂人员随意进出，为工地现场埋下诸多安全隐患；工人出勤缺乏电子记录，工资核算与支付证据链不清。'},
                                {title:'2）工地现场安全风险多，人员伤亡事故损失大',info: '升降机、塔吊、高支模、深基坑等高发事故危险源点多、线长、面广，单靠人力巡检排查，工作效率低，而且难以做到全过程、全方位的监督管理，容易出现监管漏洞。'},
                                {title:'3）工地环境污染监测困难，预防效果不明显',info: '施工现场的扬尘、噪声、污水排放的监测工作存在周期长、数据量大的特点，传统方式依靠人工测量，耗费人力，工作效率低，记录的数据缺乏客观性及说服力。与此同时，数据只能用于后期追责，做不到前期预防，及时防治。'},
                                {title:'4）工地监管成本大，问题事故回溯难',info: '政府管理部门无法实时对辖区所有工地进行全方位监控及管理。施工企业无法实时对工地生产进度及安全措施进行全方位监控。安全事故发生后，企业缺少可靠的数据，难以定责，增加了事故处理的难度；施工企业无法对事故原因准确分析，降低了事故预防的可靠性。'},
                            ]}
                    ],
                    programme:[{
                        image:ConstructionShow,info:'智慧工地解决方案依据住建部发布的指示，根据对工地行业背景和现状的分析，为了进一步落实工地安全监管责任，提高工地现场远程管理水平，加快企业对工地安全隐患处理的速度，以安全监控、绿色环保、高效管理、以人为本为核心，以物联网技术为手段的智慧工地物联网应运而生，逐步普及，且越来越得到施工行业企业及相关监管部门的重视。'
                    }],
                    customerTitle:'客户价值',
                    customer:[
                        {title:'一、统一无线接入标准、可实现社区2~3km、室内及室外连续覆盖，避免信息孤岛。',info:['LoRa技术远距传输、覆盖范围广、低功耗。','LoRa穿透力强、覆盖成本更低、容易部署。']},
                        {title:'二、系列化工业级网关适配社区多应用场景，轻量级网路降低客户TCO成本，拓展客户盈利渠道。',info:['系列化网关适配多场景，信号补盲成本低，更容易实现网络深度覆盖。','LoRa网关辐射小，社区建设易选址，网络部署周期缩短50%以上。','连接成本低，运营费用降低60%以上，商业运营模式更灵活。']},
                        {title:'三、 灵活组态的创新通用传感组件平台GSP和应用管理平台infiCombo2.0，助力客户快速开发集成丰富的物联网应用场景。',info:[' GSP开放性、组件化平台，可灵活组态应用终端，使能合作伙伴快速开发适配碎片化应用场景、多种供电模式、各种工业标准接口、接入数千种传统传感器的应用。低成本、高效、快速集成。','InfiCombo2.0应用管理平台降低物联网集成商的门槛和投入，无需通信认证开发，快速开发应用集成交付，且提供二次开发接口给大型的应用平台提供商。']},
                        {title:'四、主导物联网生态圈，联合1300+合作伙伴提供商用更成熟、丰富的应用及端到端解决方案。',info:['商业应用更成熟、终端成本更低。 ','网络开放性、可扩展性好，生态链更丰富且成熟。']},
                    ],
                }
            }
        }
    }
</script>

<style lang="scss" src="../../solution-page.scss" scoped>

</style>
